// client/src/api/userService.js
// Supprimé axios car il n'est pas utilisé
import { getAuthToken, getUserProfile as getProfileFromStorage } from '../utils/localStorage';

// Gardé pour une utilisation future, ajouté commentaire pour eviter l'avertissement ESLint
// eslint-disable-next-line no-unused-vars
const API_URL = '/api/users';

// Fonction pour récupérer le profil de l'utilisateur actuel
export const getCurrentUser = async () => {
  try {
    const token = getAuthToken();

    if (!token) {
      throw new Error('Not authenticated');
    }

    // Pour le développement, utiliser le localStorage
    const userProfile = getProfileFromStorage();

    if (!userProfile) {
      throw new Error('User profile not found');
    }

    return {
      success: true,
      user: userProfile
    };
  } catch (error) {
    throw new Error(error.message || 'Failed to get user profile');
  }
};

// Fonction pour mettre à jour le profil de l'utilisateur
export const updateProfile = async (userData) => {
  try {
    const token = getAuthToken();

    if (!token) {
      throw new Error('Not authenticated');
    }

    // Pour le développement, simuler une mise à jour
    const currentProfile = getProfileFromStorage() || {};
    const updatedProfile = { ...currentProfile, ...userData };

    // Sauvegarder dans le localStorage
    localStorage.setItem('elemental_duelists_user_profile', JSON.stringify(updatedProfile));

    return {
      success: true,
      user: updatedProfile
    };
  } catch (error) {
    throw new Error(error.message || 'Failed to update profile');
  }
};

// Fonction pour récupérer le classement des joueurs
// API réelle (/api/stats/rankings) avec fallback mock si indisponible
export const getRankings = async () => {
  const userProfile = getProfileFromStorage();
  try {
    const res = await fetch('/api/stats/rankings?limit=20', {
      headers: getAuthToken() ? { Authorization: `Bearer ${getAuthToken()}` } : {},
    });
    if (!res.ok) throw new Error('rankings HTTP ' + res.status);
    const data = await res.json();
    if (!data.success || !Array.isArray(data.rankings)) throw new Error('rankings invalide');

    // Position de l'utilisateur courant dans le classement
    let myRank = null;
    if (userProfile) {
      const found = data.rankings.find((r) => r.id === userProfile.id);
      myRank = found ? (found.position ?? found.rank ?? null) : null;
    }

    return {
      success: true,
      rankings: data.rankings,
      myRank,
      real: true,
    };
  } catch (error) {
    console.warn('[rankings] API indisponible:', error.message);
    return { success: true, rankings: [], myRank: null, real: false };
  }
};

// Fonction pour récupérer le profil utilisateur - garder son nom original pour la compatibilité
export const getUserProfile = () => {
  // Utiliser la fonction importée de localStorage
  return getProfileFromStorage();
};

// Fonction pour récupérer les statistiques utilisateur
export const getUserStats = async () => {
  try {
    // Pour le développement, simuler des données
    const userProfileStr = localStorage.getItem('elemental_duelists_user_profile');
    if (!userProfileStr) {
      throw new Error('User profile not found');
    }

    // Générer des statistiques factices sans déclarer la variable inutilisée
    return {
      success: true,
      stats: {
        games: Math.floor(Math.random() * 50),
        wins: Math.floor(Math.random() * 30),
        losses: Math.floor(Math.random() * 20),
        cardsCollected: Math.floor(Math.random() * 200),
        decksCreated: Math.floor(Math.random() * 5)
      }
    };
  } catch (error) {
    throw new Error('Failed to get user stats');
  }
};

// Exportation par défaut
const userService = {
  getCurrentUser,
  updateProfile,
  getRankings,
  getUserProfile, // Exporté avec son nom original
  getUserStats
};

export default userService;